import { ACCOUNT_ARTICLES } from "./account";
import { BILLING_ARTICLES } from "./billing";
import { COLLECTION_ARTICLES } from "./collection";
import { GETTING_STARTED_ARTICLES } from "./gettingStarted";
import { SUPPORT_ARTICLES } from "./support";
import { SURVEY_ARTICLES } from "./surveys";
import { TEAM_ARTICLES } from "./team";

/**
 * Every User Guide article, in the order the guide lists them; articles of
 * the same category are grouped under its heading.
 *
 * {
 *    id: "create-a-survey",          // unique, lowercase-with-dashes; used in #links
 *    category: "Surveys",
 *    title: "Create a survey",
 *    summary: "One sentence shown under the title in the list.",
 *    roles: [...],                   // optional: only these roles see it (see articleRoles.js)
 *    related: ["publish-and-share"], // optional: ids listed under "Related articles"
 *    body: `Markdown`                // [text](#other-article-id) opens another article,
 *                                    // [text](/route) opens that page of the app
 * }
 */
export const USER_GUIDE = [
   ...GETTING_STARTED_ARTICLES,
   ...SURVEY_ARTICLES,
   ...COLLECTION_ARTICLES,
   ...TEAM_ARTICLES,
   ...ACCOUNT_ARTICLES,
   ...BILLING_ARTICLES,
   ...SUPPORT_ARTICLES
];
